enum UserRoles {
  VISITOR = "visitor",
  SPECIALIST = "specialist",
  MODERATOR = "moderator",
  ADMIN = "admin",
}

export default UserRoles;
